import { Col, Row, Switch, Spin } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Back, BigContentContainer } from "../../globalComponents/globalStyle";
import {
  ActiveToggle,
  CommunityTopBar,
  End,
  InSessionContainer,
  ListenersList,
  SessionFooter,
  SingleSpeaker,
  Sound,
  SpeakersList,
  SwitchContainer,
  SwitchTitle,
  TextContainer,
  TogglerContainer,
} from "../Chat/Style";
import { FaHandPaper, FaHandPointUp, FaPeopleCarry } from "react-icons/fa";
import {
  BiLock,
  BiLockOpen,
  BiLogOut,
  BiMenu,
  BiNotificationOff,
} from "react-icons/bi";
import { FiMicOff } from "react-icons/fi";
import { BsFillMicFill } from "react-icons/bs";
import { useLocation, useParams } from "react-router-dom";
import Room from "../../app/Room";
import UserAvatar from "../../globalComponents/UserAvatar";
import { motion, AnimatePresence } from "framer-motion";
import { VoiceMenuSettings } from "../../globalComponents/VoiceMenuContainer";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { showFloatedVoiceSettings } from "../../app/store";
import { MdAccountCircle } from "react-icons/md";
import styled from "styled-components";
import { NotificationAlert } from "../../utils/NotificationAlert";
import { GiHand } from "react-icons/gi";
import { useQuery } from "@apollo/client";
import { GET_VOICE_CHAT_DETAIL } from "../../app/apollo";
import Speaker from "./components/Speaker";
import NoSpeaker from "./components/NoSpeaker";
import { CgMenu } from "react-icons/cg";

const UserOption = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  /* transition: all 300ms;
  transition-delay: 500ms; */
  background-color: ${(prop) => prop.theme.foreground};
  box-shadow: ${(prop) => prop.theme.subtleShadow};
  top: 1px;
  left: 1px;
  pointer-events: none;
  opacity: 0;
`;

const UserOptions = ({
  firstName,
  userId,
}: {
  firstName: string;
  userId: string;
}) => {
  return (
    <UserOption className="user-option">
      <h6 className="title-bold">{firstName}</h6>
      <div
        onClick={() => Room.adminAddUserAsSpeaker(userId)}
        className="title-medium"
      >
        Make a speaker
      </div>
      <div
        onClick={() => Room.adminKickOutUser(userId)}
        className="title-medium"
      >
        Kick User
      </div>
      <div onClick={() => Room.adminBlockUser(userId)} className="title-medium">
        Block user
      </div>
      {/* <div onClick={()=>Room.}  className="title-medium" >Drop hand</div> */}
    </UserOption>
  );
};

const ActiveCommunity: React.FC = () => {
  const params = useParams<{ id: string }>();
  const isSpeaker = useLocation<any>().state?.isSpeaker;
  const dispatch = useAppDispatch();
  const userInfo = useAppSelector((state) => state.userInfoReducer.content);
  const storeState = useAppSelector((state) => state.room);

  const { data, loading, error } = useQuery(GET_VOICE_CHAT_DETAIL, {
    variables: {
      byId: parseInt(params.id),
    },
  });

  console.log(!Room.isOpen, "isOpened check");

  useEffect(() => {
    if (params?.id) {
      if (!storeState.joinedRoom) {
        Room.createRoom(params?.id).then((e) => {
          Room.join(
            `${userInfo?.firstname} ${userInfo?.lastname}`,
            params?.id,
            userInfo.id,
            storeState.joinedRoomToken,
            isSpeaker
          );
        });
        NotificationAlert("success", "joined!", "joined a room");
      } else {
        console.log(Room.roomId, "state check 2");
        console.log(storeState.joinedRoomId, "state check");
        if (String(Room.roomId) !== String(storeState.joinedRoomId)) {
          Room.exit();
          Room.join(
            `${userInfo?.firstname} ${userInfo?.lastname}`,
            params?.id,
            userInfo.id,
            storeState.joinedRoomToken,
            isSpeaker
          ).then((e) => {
            NotificationAlert("success", "joined!", "joined a room");
          });
        }
        NotificationAlert("success", "Welcome back", "Window resumed!");
      }
    }
    dispatch(showFloatedVoiceSettings(false));
    return () => {
      dispatch(showFloatedVoiceSettings(true));
    };
  }, []);

  const [activeChat, setActiveChat] = useState(2);
  const toggleActiveChat = (num: number) => {
    if (activeChat === num) {
      return;
    } else {
      setActiveChat(num);
    }
  };
  const roomState = useAppSelector((state) => state.room);

  const listeners = useMemo(
    () =>
      Object.values(roomState.usersInRoom)
        .filter((user) => !user.isSpeaker)
        .map((speaker, index) => (
          <SingleSpeaker key={speaker.id}>
            <UserAvatar
              size={85}
              firstname={speaker?.firstname}
              lastname={speaker?.lastname}
              img={speaker?.picture}
            />

            <h3 className="title-regular">
              {speaker?.firstname} {speaker?.lastname}
            </h3>

            {speaker.isHandRaised && (
              <div className="pointer">
                <motion.div
                  animate={{ rotate: 30 }}
                  transition={{
                    repeat: 7,
                    repeatType: "reverse",
                    duration: 1,
                  }}
                >
                  <GiHand color="#a59a00" size={30} />
                </motion.div>
              </div>
            )}
            {roomState.userPriviledge === "MODRATOR" && (
              <div className="admin-settings">
                <BiMenu />
                <UserOptions
                  firstName={speaker?.firstname}
                  userId={speaker.id}
                />
              </div>
            )}
          </SingleSpeaker>
        )),
    [roomState.usersInRoom]
  );

  const speakers = useMemo(
    () =>
      Object.values(roomState.usersInRoom)
        .filter((user) => user.isSpeaker)
        .map((speaker, index) => (
          <Speaker
            image={speaker.picture}
            firstName={speaker.firstname}
            lastName={speaker.lastname}
            key={speaker.id}
            isRaiseHand={speaker.isHandRaised}
            iAmModrator={roomState.userPriviledge === "MODRATOR"}
            userId={speaker.id}
          />
        )),
    [roomState.usersInRoom]
  );

  return (
    <div>
      <TextContainer>
        <Row style={{ height: "100%" }} justify="space-between">
          <Col md={{ span: 17 }} style={{ height: "100%" }}>
            <SwitchContainer>
              <CommunityTopBar>
                {!loading ? (
                  <>
                    <>
                      <h3 className="title-bold">
                        # {data?.getVoiceChatDetails?.title}
                      </h3>
                      <div className="title-medium">
                        {data?.getVoiceChatDetails?.channel_type || ""}{" "}
                        Discussion{" "}
                        {data?.getVoiceChatDetails?.channel_type ===
                        "PUBLIC" ? (
                          <BiLockOpen color="green" />
                        ) : (
                          <BiLock color="red" />
                        )}{" "}
                      </div>
                    </>
                    <div>
                      <MdAccountCircle size={30} />
                      <h2
                        className="title-regular"
                        style={{ marginRight: "5px" }}
                      >
                        {" "}
                        Created by {}
                      </h2>
                      <UserAvatar
                        img={data?.getVoiceChatDetails?.host?.photolink}
                        firstname={
                          data?.getVoiceChatDetails?.host?.firstname || ""
                        }
                        lastname={
                          data?.getVoiceChatDetails?.host?.lastname || ""
                        }
                        size={30}
                      />
                      <h2 className="title-medium">
                        {data?.getVoiceChatDetails?.host?.firstname}{" "}
                        {data?.getVoiceChatDetails?.host?.lastname}{" "}
                      </h2>
                    </div>
                  </>
                ) : (
                  <>
                    {" "}
                    <h2>Loading... </h2> <Spin />
                  </>
                )}
              </CommunityTopBar>
              <InSessionContainer>
                <Row>
                  <div
                    onClick={() => Room.incCounter()}
                    className="title-medium"
                  >
                    Speaker(s)
                  </div>
                  <Separator />
                </Row>
                <SpeakersList>
                  {speakers.length === 0 && <NoSpeaker />}
                  <Row justify="start">{speakers}</Row>
                </SpeakersList>
                <br />
                <Row>
                  <div className="title-medium">Listener(s)</div>
                  <Separator />
                </Row>
                <ListenersList>
                  <Row justify="start">{listeners}</Row>
                </ListenersList>
              </InSessionContainer>
              <SessionFooter>
                {/* {" "}
                <div>
                  <div>
                    <FaHandPaper />
                    <h3>Raise hand</h3>
                  </div>
                  <div onClick={()=>Room.produce("audioType")}>
                    <BsFillMicFill />
                    <h3>Mute</h3>
                  </div>{" "}
                  <div style={{ color: "red" }}>
                    <BiLogOut />
                    <h3 style={{ color: "red" }}>End</h3>
                  </div>
                </div> */}
                <AnimatePresence>
                  {!storeState.floatVoiceSettings && (
                    <motion.div layoutId="voiceSettings">
                      <VoiceMenuSettings />
                    </motion.div>
                  )}
                </AnimatePresence>
              </SessionFooter>
            </SwitchContainer>
          </Col>
          <Col md={{ span: 6 }} style={{ height: "100%" }}>
            {" "}
            <SwitchContainer showBg>
              <TogglerContainer>
                <ActiveToggle
                  onClick={() => toggleActiveChat(2)}
                  active={activeChat === 2 && true}
                >
                  Notifications
                </ActiveToggle>

                {roomState.userPriviledge === "MODRATOR" && (
                  <ActiveToggle
                    onClick={() => toggleActiveChat(1)}
                    active={activeChat === 1 && true}
                  >
                    Settings
                  </ActiveToggle>
                )}
              </TogglerContainer>
              {activeChat === 1 ? <Settings /> : <Notification />}
            </SwitchContainer>
          </Col>
        </Row>
      </TextContainer>
    </div>
  );
};

export default ActiveCommunity;

const Settings = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "0 0.5vw",
      }}
    >
      <SwitchTitle>Mute All</SwitchTitle>
      <Switch />
    </div>
  );
};

const Notification = () => {
  const notifications = useAppSelector((state) => state.room).notification;
  return (
    <NotificationContainer>
      {notifications.map((item) => (
        <NotificationItem>
          <BiNotificationOff /> {item.message}
        </NotificationItem>
      ))}
    </NotificationContainer>
  );
};

const Separator = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${(prop) => prop.theme.separator};
`;

const NotificationContainer = styled.div`
  padding: 16px;
  overflow-y: scroll;
  height: 90%;
  &::-webkit-scrollbar {
    width: 5px;
    background: ${(props) => props.theme.backgroundDim};
  }
  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.background};
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.primaryColor};
    height: 15px;
    border-radius: 5px;
  }
`;

const NotificationItem = styled.div`
  font-size: 12px;
  margin: 10px 0;
`;
